<template lang="pug">
  section#issues
    div
      div.issue(
        v-for="(issue, issueKey) in comics.find(({ name }) => name === $route.params.name).issues"
        :key="issueKey"
      )
        router-link.title(
          :to="`/comic/${$route.params.name}/${issueKey}/0`"
        ) {{ issue.title }}

        router-link(
          v-for="(slide, slideKey) in issue.slides"
          :to="`/comic/${$route.params.name}/${issueKey}/${slideKey}`"
          :key="slideKey"
        ) \#{{ slideKey }}
</template>

<style lang="sass" scoped>
  #issues
    padding: 25px 0
    display: flex
    justify-content: center
    align-items: center
    min-height: 100vh

  .issue
    display: flex
    flex-wrap: wrap
    padding: 20px

    .title
      width: 100%
      margin-bottom: 10px
      font-weight: bold

    a
      margin: 0 5px

  a
    color: var(--sidebar-link)
    display: block
</style>

<script>
  import { comics } from '../../config.js'

  export default {
    data () {
      return { comics }
    }
  }
</script>